import ProductCard from '@/components/common/ProductCard/VerticalLightningHome';
import { AddToCartReferType } from '@/constants/track';
import { CmsComponentProps } from '@/types/cms';
import { getDeliveryDate } from '@/utils/common/porder';
import LightningTitle from './LightningTitle';
import More from '../Layout/more';
import Container from '../Layout/container';
import withFetch from '../../hooks/fetch';
import LazyView from '@/components/common/LazyLoad/view-lazy';
import ProductCardSkeleton from '@/components/common/Skeleton/new-product-card';
import { useMemo } from 'react';
import { StatusEnum } from '@/types/cart';
import useAccount from '@/store/account';
import { filterMaxPurchasedProducts } from '@/utils/productFormat';
import { twMerge } from 'tailwind-merge';

const LightningDeals: React.FC<CmsComponentProps> = props => {
  const {
    cmsComponentKey,
    properties,
    componentPosition,
    isStatic,
    postUrl,
    trackingContext,
    skeleton,
    customAddCartApi,
    showSoldBy,
    className
  } = props;
  const eventKey = properties?.event_key || cmsComponentKey;

  const { userBoughtData } = useAccount();

  const { data, load } = withFetch({
    data: props.data,
    isStatic: isStatic ?? false,
    postUrl: postUrl
    // componentDataSourceKey
  });

  const moreLink = useMemo(() => {
    return properties?.more_link || data?.more_link || '';
  }, [properties, data]);

  if (isStatic && !data) return null;

  if (load) return skeleton;

  const notMaxLimitProducts = props?.filterMaxPurchasedCard
    ? filterMaxPurchasedProducts(data?.products, userBoughtData)
    : data?.products;

  if (notMaxLimitProducts?.length) {
    return (
      <Container
        cmsComponentKey={cmsComponentKey}
        className={twMerge('overflow-hidden', className)}
        aria-label={properties?.title}>
        <LightningTitle
          {...props}
          data={data}
          hideTimeString={true}
          trackingParams={{
            mod_nm: eventKey,
            mod_pos: `${componentPosition}`,
            co: {
              target_pos: data?.products?.length
            }
          }}
        />
        <div
          className="mt-2.5 mb-100 flex items-stretch flex-row overflow-x-scroll"
          role="list"
          aria-label={`${properties?.title} list`}>
          {notMaxLimitProducts?.map((item, index) => {
            return (
              <div role="listitem" className="w-[150px] shrink-0 mr-4 first:ml-5 last:mr-5" key={index}>
                <LazyView rootMargin="6px 0px 0px 6px" skeleton={index > 5 && <ProductCardSkeleton />}>
                  <ProductCard
                    isLightningDeals={true}
                    countDownTimeStamp={data?.current_timestamp || data?.server_timestamp_now}
                    showAddBtn={item?.status !== 'ongoing' || item?.sold_status === StatusEnum.sold_out ? false : true}
                    showLeft={true}
                    showActivity={true}
                    showProgress={data.show_progress}
                    addCartParams={{
                      referType: AddToCartReferType.normal,
                      deliveryDate: getDeliveryDate()
                    }}
                    positionInfoT2={{
                      modSecPos: {
                        mod_nm: eventKey,
                        mod_pos: componentPosition
                      },
                      prodPos: index,
                      context: {
                        global_vendor: item?.biz_type === 'seller' ? item?.vender_id : null,
                        ...trackingContext
                      }
                    }}
                    miniTitle={true}
                    fixedTitletHeight={true}
                    showFavorite={false}
                    showWeekly={false}
                    data={item}
                    showSoldBy={showSoldBy}
                    customAddCartApi={customAddCartApi}
                    deliveryDate={getDeliveryDate()}
                  />
                </LazyView>
              </div>
            );
          })}
          {!!moreLink && (
            <div
              role="listitem"
              className="w-[150px] min-h-[234px] shrink-0 mr-4 first:ml-5 last:mr-5 flex items-center">
              <More
                moreLink={moreLink}
                trackingParams={{
                  mod_nm: eventKey,
                  mod_pos: `${componentPosition}`,
                  co: {
                    target_pos: data?.products?.length
                  }
                }}
              />
            </div>
          )}
        </div>
      </Container>
    );
  }
  return null;
};

export default LightningDeals;
